import { Pipe, PipeTransform } from '@angular/core';
import { OffCanvasComponents } from '../off-canvas-service/off-canvas-form.service';
import { OptimaOffCanvasService } from '@optima-stride-ai/optima-components';

@Pipe({
  name: 'formSelector'
})
export class FormSelectorPipe implements PipeTransform {
  transform(lvl: number, service: OptimaOffCanvasService, comp2: OffCanvasComponents): boolean {
      const decision = service.getLastOffCanvasAtLevel(lvl)?.componentInOffCanvas == comp2;
    return decision;
  }
}

